export default "__VITE_ASSET__BdHl8jW1__"